import { ErrorMessage, useField, useFormikContext } from "formik";
import { Badge } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { format_percent_2 } from "../../common/format";

const SelectControlValues = (props) => {

    const {
        columns,
        itens,
        value
    } = props;

    const {
        handleChange
    } = useFormikContext();

    const [fieldId, metaId, handleId] = useField(props.name);

    return (
        <>
            <Form.Group>
                {!props.hideTitle && <Form.Label className="mb-0">{props.placeholder}</Form.Label>}

                <Form.Select
                    {...props}
                    value={value ?? metaId.value}
                    onChange={(e) => {
                        console.log(e.target.value)
                        // console.log(e.target.attributes.value)
                        handleChange(e);
                        props.onChange && props.onChange(e);
                    }}
                    onBlur={(e) => props.onBlur ? props.onBlur(e) : e.target.blur()}
                >
                    {props.nulloption && (
                        <option key={0} value={0}>
                            {null}
                        </option>
                    )}
                    {itens?.map((item, i) => {
                        const index = props.nulloption ? i + 1 : i;
                        const colunasEValores = columns.map((coluna) => {
                            const indexValor = Object.keys(item).findIndex(
                                (element) => {
                                    return element === coluna.field
                                }
                            )
                            return format_percent_2.format(Object.values(item)[indexValor]);
                        })

                        return (
                            <option key={index} item={item} value={item.Id}>
                                
                                {columns.map((coluna, i) => {
                                    return (
                                        <span key={i}>
                                            {colunasEValores[i]} 
                                            {i < columns.length - 1 && " | "}
                                        </span>
                                    )
                                })}
                            </option>
                        );
                    })}
                </Form.Select>
                <ErrorMessage name={props.name}>
                    {(msg) => (
                        <Badge bg="danger">{msg}</Badge>
                    )}
                </ErrorMessage>
            </Form.Group>
        </>
    )
}

export default SelectControlValues;
